<template>
	<div class="maxMaxth evebt _cgen">
		<div style="padding: .2rem;">
			<div class="ULG1B14hvGovlx7vmyCA">
				<div class="N63rAcXzSqG9iqV4Flat">
					<div class="L5_1tmwMVoGtI9AqIqqL">{{ $t('_VIP._Totaldedepósitos') }}</div>
					<div class="P1ozSFRLF7DJUfblUyQh">
						<div> 0,00</div>
					</div><button type="button" class="ant-btn k_0K0wRKXuPGcm49OQkv"><span
							class="N4LsWhJBhqqyTkv6V0NE auto-shrink-text recharge"
							style="width: 100%; margin-bottom: -1.22353px; padding-bottom: 1.22353px;"><span
								class="ke1kCzBARxq5HSxbDQ6h" style="font-size: 10.4px;"><span
									class="TMZWYZcIv5YQXVdFMVrw inner-text"
									style="-webkit-line-clamp: 2;">{{ $t('_VIP._Depósito') }}</span></span></span>
						<div class="uh6csli2MHzFz87__Phx tool-tips hvhFGlLKPpG0bri8ybC6"
							style="--cu-top: -0.1rem; --cu-right: 0rem; --cu-left: 0.2rem;">
							<div class="tool-tips-box sNgyWmhVEZVrbSGKDBra">{{ $t('_VIP._Bônus') }}100%</div>
							<div class="tool-tips-tail YiNQnpSJUes7u5sqBZhp"></div>
						</div>
					</button>
					<div class="JthdABf_GjpvNXvvnA0m">
						<div class="Sq28C8dssNh13cCJfADN">{{ $t('_VIP._BônusMáximoNãosertapado') }}<span
								class="WbfuzI4g5_jqIuzb1I1P">{{ $t('_VIP._Nãosertapado') }}</span></div>
						<div class="Sq28C8dssNh13cCJfADN">{{ $t('_VIP._LimiteMáximoNãosertapado') }}<span
								class="WbfuzI4g5_jqIuzb1I1P">{{ $t('_VIP._Nãosertapado') }}</span></div>
					</div>
				</div>
				<!-- 
					
				-->
				<span class="yFOofIyO_0iWEYgUk0zu"></span>
				<div class="N63rAcXzSqG9iqV4Flat">
					<div class="L5_1tmwMVoGtI9AqIqqL">{{ $t('_VIP._FundodePrevidência') }}</div>
					<div class="P1ozSFRLF7DJUfblUyQh EnmjutsbF4EUX1XjNPG4">
						<div> 0,00</div>
					</div><button disabled="disabled" type="button" class="ant-btn jrj_7hgWS_Pzd5mvGPs1"><span
							class="N4LsWhJBhqqyTkv6V0NE auto-shrink-text"
							style="width: 100%; margin-bottom: -1.22353px; padding-bottom: 1.22353px;"><span
								class="ke1kCzBARxq5HSxbDQ6h" style="font-size: 10.4px;"><span
									class="TMZWYZcIv5YQXVdFMVrw inner-text"
									style="-webkit-line-clamp: 2;">{{ $t('_VIP._Retira') }}</span></span></span></button>
					<div class="nxucLctvQRgdORJaIS3Q">
						<div class="grAFjLQGR5EPtNmvx8m5 rechargeDowmTime"><span></span></div>
					</div>
				</div>
			</div>
			<van-tabs v-model="activeName" @click="routerFun" :lineWidth="(activeLength*6+'px')" animated
				line-height="2px" class="ss-van-tab" background="var(--theme-main-bg-color)" :ellipsis="false"
				title-active-color="var(--theme-primary-color)" title-inactive-color="var(--theme-text-color-darken)"
				color="var(--theme-primary-color)">
				<van-tab title-style="font-size: 0.22rem;" v-for="(item,index) in tabList" :title="$t(item.name)"
					:name="index" :key="index">

					<div class="mHlQTGotPEK_5f9LYDfx" v-if="tabList[activeName].name=='popup._Totalderegistros'">
						<div class="gPcijFU0IRrnGWDIffcn">
							<div class="xt8diCxLPJPPG8DQq5Yg">
								<datetimePicker class="ifzwCQu8BPs2c24nZdzQ"></datetimePicker>
							</div>

							<div class="VvaPhypYYq8uhP316mGm">
								<div>{{ $t('_VIP._acumulaçãototal0') }}</div>
								<span class="currencyAmount"> 0,00</span>
							</div>
						</div>
						<!-- '' -->
						<van-row class="tenConter _border" style="background: var(--theme-main-bg-color) !important;">
							<van-col class="tr" span="8">{{ $t('_VIP._Horário') }}</van-col>
							<van-col class="tr" span="8">{{ $t('_VIP._Depósito') }}</van-col>
							<van-col class="tr" span="8">{{ $t('_VIP._Taxadebônus') }}</van-col>
							<van-col class="tr" span="8">{{ $t('_VIP._Taxadebônus') }}</van-col>

						</van-row>
						<div class="juconterConter" style="height: calc(var(--vh, 1vh)* 100 - 7.5rem) !important;">
							<van-empty image-size="2.1rem" class="custom-image" :image="img_none_sj"
								:description="$t('description')" />
						</div>

					</div>
					<div class="mHlQTGotPEK_5f9LYDfx" v-if="tabList[activeName].name=='popup._RequisitosDeapostas'">
						<div class="gPcijFU0IRrnGWDIffcn">
							<div class="xt8diCxLPJPPG8DQq5Yg">
								<datetimePicker class="ifzwCQu8BPs2c24nZdzQ"></datetimePicker>
							</div>

							<div class="VvaPhypYYq8uhP316mGm">
								<div>{{ $t('_VIP._Vocêprecisaapostar') }}</div>
								<span class="currencyAmount"> 0,00</span>
							</div>
						</div>
						<van-row class="tenConter _border" style="background: var(--theme-main-bg-color) !important;">
							<van-col class="tr" span="8">{{ $t('_VIP._Horário') }}</van-col>
							<van-col class="tr" span="8">{{ $t('_VIP._Depósito') }}</van-col>
							<van-col class="tr" span="8">{{ $t('_VIP._Númerodeapostas') }}</van-col>
							<van-col class="tr" span="8">{{ $t('_VIP._Novosrequerimentosparaaposta') }}</van-col>
						</van-row>
						<div class="juconterConter" style="height: calc(var(--vh, 1vh)* 100 - 7.5rem) !important;">
							<van-empty image-size="2.1rem" class="custom-image" :image="img_none_sj"
								:description="$t('description')" />
						</div>
					</div>
					<div class="ZqKoc003Qi4Madfyrmji" v-if="tabList[activeName].name=='popup._Regras'">
						<div class="SH1wTnZeFa_E0XnrYVH6">
							<div><span class="JmouHouhyqwnGFKDLCoG">1、 {{$t('_VIP._presenteMeLOfgn')}}: </span>{{$t('_VIP._recarregar')}}</div>
							<div><span class="JmouHouhyqwnGFKDLCoG">2、 {{$t('_VIP._Condies') }}: </span>{{$t('_VIP._Cadaprevid') }}</div>
							<div><span class="JmouHouhyqwnGFKDLCoG">3、 {{$t('_VIP._BnusMximo') }}: </span>{{$t('_VIP._gratuitos')}}</div>
							<div><span class="JmouHouhyqwnGFKDLCoG">4、 {{$t('_VIP._Redefinirciclo') }}: </span>{{$t('_VIP._retiradoMense_mes') }}</div>
							<div><span class="JmouHouhyqwnGFKDLCoG">5、 {{$t('_VIP._Auditoriamltipla') }}: </span>{{$t('_VIP._fundoRetirado') }}</div>
							<div><span class="JmouHouhyqwnGFKDLCoG">6、 {{$t('_VIP._Recebarestries') }}: </span>{{$t('_VIP._apenasAndroid')}}</div>
							<div><span class="JmouHouhyqwnGFKDLCoG">7、 {{$t('_VIP._Violadasregras') }}: </span>{{$t('_VIP._meSomente')}}</div>
							<div><span class="JmouHouhyqwnGFKDLCoG">8、 {{$t('_VIP._Aexplicainal') }}: </span>{{$t('_VIP._Paraevitar') }}</div>
						</div>
					</div>
				</van-tab>
			</van-tabs>

		</div>

	</div>
</template>

<script>
	import datetimePicker from "@/components/searchFor/datetimePicker.vue";
	import dropdownMenu from "@/components/dropdown-menu/index.vue"
	export default {
		name: 'yuebao',
		components: {
			dropdownMenu,
			datetimePicker
		},
		data() {
			return {
				showPopover: false,
				showPopover_a: false,
				actions: [{
					text: '选项一'
				}, {
					text: '选项二'
				}, {
					text: '选项三'
				}],
				activeLength: "20",
				activeName: 0,
				tabList: [{
						name: 'popup._Totalderegistros',
						route: "event"
					},
					{
						name: 'popup._RequisitosDeapostas',
						route: "vip"
					},
					{
						name: 'popup._Regras',
						route: "vip"
					}
				],
				// _Totalderegistros:"Total de registros",
				// _RequisitosDeapostas:"Requisitos de apostas",
				// _Regras:"Regras",
			}
		},
		methods: {
			routerFun(e, l) {
				this.activeLength = l.length;
			},
			tabFun(e) {
				this.$store.commit('active', e)
			},
			onConfirm() {
				this.$refs.item.toggle();
			},
			stickyScroLL(e) {

			}
		}
	}
</script>
<style>
	._cgen .ss-van-tab {
		background: var(--theme-main-bg-color) !important;
		border-radius: .2rem;
		overflow: hidden;
	}

	._cgen .ss-van-tab .van-tab {
		/* display: block !important; */
		/* background-color: var(--theme-main-bg-color) !important; */
		/* background: var(--theme-main-bg-color); */
		flex: none !important;
	}

	._cgen .ss-van-tab .van-tabs__wrap--scrollable {
		border-bottom: .01rem solid var(--theme-color-line);
	}
</style>
<style scoped>
	.van-popover__content {
		background-color: var(--theme-main-bg-color) !important;
		border: .01rem solid var(--theme-color-line) !important;
		border-radius: .1rem;
		-webkit-box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .1);
		box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .1);
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		overflow: hidden
	}

	.van-popover__action {
		font-size: .24rem;
		line-height: .8rem;
		min-height: .8rem;
		background-color: var(--theme-main-bg-color);
		color: var(--theme-text-color-lighten);
		padding: 0 .2rem;
		box-sizing: border-box;
		width: 114px;
	}

	.van-popover__action-text {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-box-flex: initial;
		-webkit-flex: initial;

		/* flex: 1; */
		-webkit-box-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		height: 100%;
	}
</style>
<style scoped>
	.ULG1B14hvGovlx7vmyCA {
		-ms-flex-pack: justify;
		background-color: var(--theme-main-bg-color);
		border-radius: .1rem;
		-webkit-box-shadow: 0 .03rem .09rem 0 var(--theme-bg-shadow);
		box-shadow: 0 .03rem .09rem 0 var(--theme-bg-shadow);
		display: -ms-flexbox;
		display: flex;
		justify-content: space-between;
		margin-bottom: .2rem;
		padding: .2rem 0
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat {
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-direction: column;
		flex-direction: column;
		width: 50%
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .rechargeDowmTime span {
		color: var(--theme-secondary-color-error) !important
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .nxucLctvQRgdORJaIS3Q span {
		color: var(--theme-primary-color);
		font-size: .18rem
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .nxucLctvQRgdORJaIS3Q i {
		font-size: .2rem
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .hvhFGlLKPpG0bri8ybC6 {
		left: .5rem;
		top: -.22rem
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .hvhFGlLKPpG0bri8ybC6:lang(my_MM) {
		top: -.2rem
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .hvhFGlLKPpG0bri8ybC6 div {
		color: #ff0
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .L5_1tmwMVoGtI9AqIqqL {
		color: var(--theme-text-color-lighten);
		font-size: .22rem;
		font-stretch: normal;
		font-style: normal;
		font-weight: 400;
		height: .27rem;
		letter-spacing: normal;
		line-height: 1.35;
		margin: 0 .73rem .08rem .74rem;
		text-align: center;
		width: -webkit-max-content;
		width: -moz-max-content;
		width: max-content
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .P1ozSFRLF7DJUfblUyQh {
		color: var(--theme-text-color-darken);
		font-size: .3rem;
		font-stretch: normal;
		font-style: normal;
		font-weight: 400;
		height: .33rem;
		letter-spacing: normal;
		line-height: 1.38;
		margin: .08rem 0 0;
		text-align: center
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .EnmjutsbF4EUX1XjNPG4 {
		color: var(--theme-secondary-color-finance);
		font-size: .36rem;
		height: .43rem;
		line-height: 1.34
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .k_0K0wRKXuPGcm49OQkv {
		-ms-flex-align: center;
		-ms-flex-pack: center;
		align-items: center;
		background-color: var(--theme-label-secondary-color-finance);
		border-color: var(--theme-label-secondary-color-finance);
		border-radius: .1rem;
		color: var(--theme-secondary-color-help-text-color);
		display: -ms-flexbox;
		display: flex;
		font-size: .2rem;
		font-weight: 400;
		height: .5rem;
		justify-content: center;
		margin: .26rem 0 .16rem;
		padding: .089rem .15rem .091rem;
		position: relative;
		width: 1.2rem
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .k_0K0wRKXuPGcm49OQkv .recharge:lang(zh_CN),
	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .k_0K0wRKXuPGcm49OQkv .recharge:lang(zh_TW) {
		letter-spacing: .34em
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .JthdABf_GjpvNXvvnA0m {
		-ms-flex-align: center;
		-ms-flex-pack: center;
		align-items: center;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		justify-content: center;
		word-break: break-all
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .JthdABf_GjpvNXvvnA0m .Sq28C8dssNh13cCJfADN {
		color: var(--theme-text-color-lighten);
		font-size: .18rem;
		font-stretch: normal;
		font-style: normal;
		font-weight: 400;
		letter-spacing: normal;
		line-height: 1.33;
		margin: 0 .15rem;
		text-align: left
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .JthdABf_GjpvNXvvnA0m .Sq28C8dssNh13cCJfADN .WbfuzI4g5_jqIuzb1I1P {
		color: var(--theme-text-color-darken);
		font-weight: 600;
		padding: 0 .03rem
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .JthdABf_GjpvNXvvnA0m .Sq28C8dssNh13cCJfADN .rHWKESAxC__xBGM6yTMF {
		vertical-align: text-bottom
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .JthdABf_GjpvNXvvnA0m .Sq28C8dssNh13cCJfADN .rHWKESAxC__xBGM6yTMF i {
		font-size: .2rem;
		margin-left: .15rem
	}

	.yFOofIyO_0iWEYgUk0zu {
		-ms-flex-item-align: center;
		align-self: center;
		background-color: var(--theme-color-line);
		display: block;
		height: 1.2rem;
		width: .01rem
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .jrj_7hgWS_Pzd5mvGPs1 {
		-ms-flex-align: center;
		-ms-flex-pack: center;
		align-items: center;
		background-color: var(--theme-secondary-color-success);
		border-color: var(--theme-secondary-color-success);
		border-radius: .1rem;
		color: #fff;
		display: -ms-flexbox;
		display: flex;
		font-size: .2rem;
		font-weight: 400;
		height: .5rem;
		justify-content: center;
		margin: .18rem 0 .16rem;
		padding: .089rem .15rem .091rem;
		width: 1.2rem
	}

	.JmouHouhyqwnGFKDLCoG {
		font-size: .22rem !important;
		font-weight: 700 !important;
	}

	.ULG1B14hvGovlx7vmyCA .N63rAcXzSqG9iqV4Flat .jrj_7hgWS_Pzd5mvGPs1:disabled {
		background-color: var(--theme-disabled-bg-color);
		border-color: var(--theme-disabled-bg-color);
		color: var(--theme-disabled-font-color)
	}

	.ULG1B14hvGovlx7vmyCA .yFOofIyO_0iWEYgUk0zu {
		-ms-flex-item-align: center;
		align-self: center;
		background-color: var(--theme-color-line);
		display: block;
		height: 1.2rem;
		width: .01rem
	}

	.ant-row-flex {
		display: flex;
		justify-content: center;
		flex-flow: row wrap;
		align-items: center;
		justify-content: space-between;
	}

	.ant-btn-a:not(.ant-btn-a-link) {
		background-color: var(--theme-disabled-bg-color);
		border-color: var(--theme-disabled-bg-color);
		color: var(--theme-disabled-font-color);
	}

	.uh6csli2MHzFz87__Phx {
		height: .32rem;
		left: var(--cu-left);
		position: absolute;
		right: var(--cu-right);
		top: var(--cu-top);
		width: -webkit-fit-content;
		width: -moz-fit-content;
		width: fit-content;
		z-index: 100
	}

	.uh6csli2MHzFz87__Phx p {
		margin-bottom: 0
	}

	.uh6csli2MHzFz87__Phx .YiNQnpSJUes7u5sqBZhp {
		border-bottom: .07rem solid transparent;
		border-left: .07rem solid var(--theme-secondary-color-error);
		border-right: .07rem solid transparent;
		height: 0;
		width: 0
	}

	.uh6csli2MHzFz87__Phx .T5xNMynUJQws22ZME9hV {
		border-bottom: .07rem solid transparent;
		border-left: .07rem solid transparent;
		border-right: .07rem solid var(--theme-secondary-color-error);
		float: right
	}

	.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra {
		background-color: var(--theme-secondary-color-error);
		border-radius: .125rem .125rem .125rem 0;
		color: #fff;
		font-size: .14rem;
		height: .22rem;
		line-height: .22rem;
		padding: 0 .08rem;
		width: 100%
	}

	.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra:lang(my_MM) {
		height: .26rem
	}

	.uh6csli2MHzFz87__Phx .CmN8CVsfet8ieqBIT7mi {
		color: #ff0
	}

	.uh6csli2MHzFz87__Phx .nc_NIDTLmXeUSFFfADOl {
		border-radius: .125rem .125rem 0 .125rem
	}

	.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra {
		font-size: .18rem;
		height: .26rem;
		line-height: .26rem;
		padding: 0 .07rem
	}




	.nt3HkYGHVSEvaGFFn12x,
	html[data-device="mobile"] .nt3HkYGHVSEvaGFFn12x .currencyAmount {
		font-size: 0.2rem;
	}


	.currencyAmount.yellowColor {
		color: var(--theme-secondary-color-finance) !important;
	}



	.SH1wTnZeFa_E0XnrYVH6 {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		font-size: .2rem;
		margin-top: 0;
		padding: .2rem;
	}

	.SH1wTnZeFa_E0XnrYVH6 div {
		margin-bottom: .2rem;
	}

	.SH1wTnZeFa_E0XnrYVH6 {
		background-color: var(--theme-main-bg-color);
		border: .01rem solid var(--theme-color-line);
		/* border-radius: .1rem; */
		border-bottom-left-radius: .1rem;
		border-bottom-right-radius: .1rem;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		min-height: 2rem;
		color: var(--theme-text-color);
		padding: .3rem;
	}

	.SH1wTnZeFa_E0XnrYVH6 :first-child {
		font-size: .2rem
	}

	.SH1wTnZeFa_E0XnrYVH6 :first-child {
		font-size: .2rem;
	}

	.ZqKoc003Qi4Madfyrmji {
		/* padding: .2rem; */
		/* padding-top: .1rem; */
	}

	.mHlQTGotPEK_5f9LYDfx {
		padding: 0 .2rem
	}

	.myDateRadio {
		border: .01rem solid var(--theme-color-line);
		background-color: var(--theme-main-bg-color);
		font-size: .2rem;
		height: .5rem !important;
		transition: all .3s cubic-bezier(.645, .045, .355, 1);
		border-radius: .5rem;
		line-height: .5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 11px;
		color: var(--theme-text-color-lighten) !important;
	}

	.myDateRadio_icon {
		color: var(--theme-text-color-lighten) !important;
		transform: rotate(-90deg);
		width: .2rem;
		height: .2rem;
		transition: all .3s cubic-bezier(.645, .045, .355, 1);
		margin-left: .1rem;
	}

	.myDateRadio_icon.a90 {
		transform: rotate(90deg) !important;
	}

	.xt8diCxLPJPPG8DQq5Yg,
	.gPcijFU0IRrnGWDIffcn {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.mHlQTGotPEK_5f9LYDfx .gPcijFU0IRrnGWDIffcn {
		-ms-flex-pack: justify;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		justify-content: space-between;
		padding: .2rem 0
	}

	.gPcijFU0IRrnGWDIffcn .VvaPhypYYq8uhP316mGm {
		-ms-flex-align: end;
		align-items: flex-end;
		display: flex;
		color: var(--theme-text-color-lighten);
		font-size: .22rem;
	}

	.tenConter {
		border-radius: .1rem;
		height: .8rem !important;
	}
</style>